export { default } from './NewsletterDetail'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterDetail/index.js